// Hex codes provided by radix-ui colors
export const COLORS: Record<string, string> = {
  CRIMSON_2: '#24171C',
  CRIMSON_5: '#5C1839',
  CRIMSON_8: '#B0436E',
  CYAN_2: '#101B20',
  CYAN_6: '#045468',
  CYAN_8: '#11809C',
  CYAN_13: '#ECFCFF',
  GRASS_3: '#1B2A1E',
  GRASS_5: '#25482D',
  GRASS_8: '#3E7949',
  GRASS_13: '#E1F1E1',
  INDIGO_5: '#374894',
  INDIGO_8: '#435DB1',
  INDIGO_11: '#9EB1FF',
  PURPLE_5: '#48295C',
  PURPLE_8: '#8457AA',
  TEAL_5: '#084843',
  TEAL_8: '#207E73',
  RED_3: '#3B1219',
  RED_4: '#500F1C',
  RED_10: '#DC3E42',
  RED_13: '#FFE5E9',
  TOMATO_7: '#853A2D',
  TOMATO_8: '#AC4D39',
  TOMATO_9: '#E54D2E',
  ORANGE_3: '#2E1F0B',
  ORANGE_8: '#A35829',
  ORANGE_13: '#FFEFD6',
  GRAY_6: '#3A3A3A',
  GRAY_12: '#CECECE',
  NOTIFICATION: '#06b290',
};
